<template>
  <div>
    <v-layout justify-center>
      <v-flex
        xs12
        sm12
        md10
        lg5
        xl5
      >
        <div class="payment-card">
          <div class="payment-card-title mb-4">Charge your account</div>
          <div class="payment-card-body">
            <div
              class="mb-4"
              style="font-size: 16px"
            >Select payment method</div>
            <div
              class="payment-methods"
              @click="selected = 'fib'"
            >
              <div class="mr-3">
                <i
                  v-if="selected == 'fib'"
                  class="fa fa-check"
                  style="color: #1976d2; font-size: 18px"
                ></i>
                <i
                  v-else
                  class="fa fa-check"
                  style="color: #fff; font-size: 18px"
                ></i>
              </div>
              <div style="width: 100px; height: 40px">
                <img
                  src="../../../assets/images/fib.svg"
                  style="width: 100%; height: 100%; object-fit: contain"
                >
              </div>
            </div>
            <div
              class="payment-methods"
              @click="selected = 'fastpay'"
            >
              <div class="mr-3">
                <i
                  v-if="selected == 'fastpay'"
                  class="fa fa-check"
                  style="color: #1976d2; font-size: 18px"
                ></i>
                <i
                  v-else
                  class="fa fa-check"
                  style="color: #fff; font-size: 18px"
                ></i>
              </div>
              <div style="width: 100px; height: 40px">
                <img
                  src="../../../assets/images/fastpay.svg"
                  style="width: 100%; height: 100%; object-fit: contain"
                >
              </div>
            </div>
            <div
              class="payment-methods"
              @click="selected = 'qi'"
            >
              <div class="mr-3">
                <i
                  v-if="selected == 'qi'"
                  class="fa fa-check"
                  style="color: #1976d2; font-size: 18px"
                ></i>
                <i
                  v-else
                  class="fa fa-check"
                  style="color: #fff; font-size: 18px"
                ></i>
              </div>
              <div style="width: 100px; height: 40px">
                <img
                  src="../../../assets/images/qi.svg"
                  style="width: 100%; height: 100%; object-fit: contain"
                >
              </div>
            </div>

            <div>
              <v-btn
                style="height: auto"
                color="primary"
                depressed
                :disabled="!selected"
                @click="nextStep()"
              >
                Next
              </v-btn>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  mounted() {
    this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
  },
  data() {
    return {
      selected: null,
      loggedInUserData: null
    }
  },

  methods: {
    nextStep() {
      if (!this.selected) return

      if (this.selected === 'fib') {
        this.$router.push('/pay-with-fib')
      } else if (this.selected === 'fastpay') {
        this.$router.push('/pay-with-fastpay')
      } else if (this.selected === 'qi') {
        this.$router.push('/pay-with-qi')
      }
    }
  }
}
</script>

<style scoped>
.payment-card {
  border: 1px solid #ddd;
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
}
.payment-card-title {
  font-size: 20px;
  font-weight: 500;
}
.payment-currency-btn .btn__content {
  width: 60px !important;
}

.payment-methods {
  /* height: 40px; */
  /* width: 130px; */
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 16px;
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/chargeBalance.vue